import { Outlet } from 'react-router-dom';
// import Header from './components/common/header/Header';
import Routing from './router';
import "./styles.scss"
import "./assets/css/responsive-style.css"
import {ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// import Sidebar from './components/common/sidebar/Sidebar';

function App() {
 
  return (
    <>
      <Routing/>
      <ToastContainer/>
    </>
  );
}

export default App;
